module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v("选择原合同")]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n    选择原合同\n    "), (_vm.attribute.description) ? _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage(_vm.attribute.description)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [(_vm.attribute.sorteditAble === false) ? _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.attribute.value
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value.split(':')[0]),
      expression: "attribute.value.split(':')[0]"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.attribute.value.split(':')[0])
    },
    on: {
      "click": function($event) {
        return _vm.showOptionList(_vm.attribute)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute.value.split(':'), 0, $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a395ee44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Cust/ContractChoose.vue
// module id = 1704
// module chunks = 8